import axios from "axios"
import { baseUrl } from "../BaseUrl"

export const envoyernotification = async(message)=>{
    return await axios.post(baseUrl('restauratrice/envoyernotification'), message);
}